// src/components/GatewayList.js
import React, { useState, useEffect } from 'react';
import { Box, Table, Thead, Tbody, Tr, Th, Td, IconButton, Button } from '@chakra-ui/react';
import { getGateways } from '../utils/firebase.utils';
import { ViewIcon, EditIcon } from '@chakra-ui/icons';
import GatewayForm from './GatewayForm';

const GatewayList = ({ onView }) => {
  const [gateways, setGateways] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState(null);

  useEffect(() => {
    const fetchGateways = async () => {
      const gatewaysList = await getGateways();
      setGateways(gatewaysList);
    };
    fetchGateways();
  }, []);

  const handleFormSubmit = () => {
    setShowForm(false);
    const fetchGateways = async () => {
      const gatewaysList = await getGateways();
      setGateways(gatewaysList);
    };
    fetchGateways(); // Refresh the list after adding or modifying a gateway
  };

  const handleEdit = (gateway) => {
    setSelectedGateway(gateway);
    setShowForm(true);
  };

  return (
    <Box p={4} overflowX="auto">
      <Button onClick={() => { setShowForm(!showForm); setSelectedGateway(null); }} mb={4}>
        {showForm ? 'Cancel' : 'Add Gateway'}
      </Button>
      {showForm && <GatewayForm gateway={selectedGateway} onSubmit={handleFormSubmit} />}
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Location</Th>
            <Th>Status</Th>
            <Th>Last Sync</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {gateways.map(gateway => (
            <Tr key={gateway.id}>
              <Td>{gateway.name}</Td>
              <Td>{gateway.location}</Td>
              <Td>{gateway.status}</Td>
              <Td>{gateway.lastSync.toLocaleString()}</Td>
              <Td>
                <IconButton
                  icon={<ViewIcon />}
                  onClick={() => onView(gateway)}
                  aria-label="View Gateway"
                  mr={2}
                />
                <IconButton
                  icon={<EditIcon />}
                  onClick={() => handleEdit(gateway)}
                  aria-label="Edit Gateway"
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default GatewayList;